const initialState =false;
const loaderReducer= (state=initialState, action)=>{
    switch(action.type){
        case 'ONLOADER':return true;
        case 'OFFLOADER':return false;
        default : return state;
    }
}
export default loaderReducer;